import {
  getFindVenueOverviewVersionQueryKey,
  useUpdateVenueOverviewVersion,
} from '@api';
import { useInvalidateQuery, useNotification } from '@common';
import { AxiosError } from 'axios';
import { VenueCompsFormDataType } from '../useVenueCompsFormSchema';

const TRANS_PATH = 'NOTIFICATIONS.UPDATE_VENUE_COMPS';

type UseUpdateVenueCompsReturnType = {
  updateVenueComps: (data: VenueCompsFormDataType) => Promise<void>;
};

type UseUpdateVenueCompsPropsType = {
  venueId: string;
  overviewVersion: string;
  onClose: () => void;
};

export const useUpdateVenueComps = ({
  venueId,
  overviewVersion,
  onClose,
}: UseUpdateVenueCompsPropsType): UseUpdateVenueCompsReturnType => {
  const { mutateAsync } = useUpdateVenueOverviewVersion();
  const { showSuccess, showError } = useNotification();

  const { invalidateQuery } = useInvalidateQuery(
    getFindVenueOverviewVersionQueryKey(venueId, overviewVersion)
  );

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_PATH}.SUCCESS.TITLE`,
      message: `${TRANS_PATH}.SUCCESS.MESSAGE`,
    });
    invalidateQuery();
    onClose();
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_PATH}.ERROR.TITLE`,
      message: `${TRANS_PATH}.ERROR.MESSAGE`,
      error,
    });
  };

  const updateVenueComps = async (
    data: VenueCompsFormDataType
  ): Promise<void> => {
    await mutateAsync(
      {
        venueId,
        overviewVersion,
        data: { venueComps: data.venueComps },
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { updateVenueComps };
};
